const model = {
  formId: 'signupForm',
  formField: {
    firstName: {
      name: 'first_name',
      label: 'First name*',
      validations: {
        required: 'First name is required',
      },
    },
    lastName: {
      name: 'last_name',
      label: 'Last name*',
      validations: {
        required: 'Last name is required',
      },
    },
    dateOfBirth: {
      name: 'date_of_birth',
      label: 'Date of Birth*',
      validations: {
        required: 'Date of Birth is required',
      },
    },
    email: {
      name: 'email',
      label: 'Email*',
      validations: {
        required: 'Email is required',
      },
    },
    password: {
      name: 'password',
      label: 'Password',
      validations: {
        required: 'Email is required',
        minLength: {
          value: 8,
          message: 'Password must by at least 8 charaters long',
        },
      },
    },
    profileType: {
      name: 'profile_type',
      label: 'Profile Type*',
      validations: {
        required: 'Profile Type is required',
      },
    },
    country: {
      name: 'country',
      label: '-- Choose Country --',
      validations: {
        required: 'Country is required',
      },
    },
    postalCode: {
      name: 'postal_code',
      label: 'Postal Code*',
      validations: {
        required: 'Postal Code is required',
      },
    },
    photo: {
      name: 'photo',
      label: 'Photo*',
    },
    heroImage: {
      name: 'hero_image',
      label: 'Profile Background*',
    },
    about: {
      name: 'about',
      label: 'Bio',
    },
    title: {
      name: 'title',
      label: 'Title',
    },
    employmentStatus: {
      name: 'employment_status',
      label: '-- Current Employment Status --',
      options: [
        { value: 'seeking', label: 'Seeking employment' },
        { value: 'employed', label: 'Employed' },
        { value: 'employed-open', label: 'Employed, but Open' },
        { value: 'student', label: 'Student' },
        { value: '', label: 'None of the above' },
      ],
    },
    businessStatus: {
      name: 'business_status',
      label: '-- Current Business Status --',
      options: [
        { value: 'make-parts', label: 'We make parts' },
        { value: 'need-parts', label: 'We need parts made' },
        { value: 'hiring', label: 'We are looking to hire' },
      ],
    },
    step: {
      name: 'step',
    },
  },
}

export default model
